import React from 'react';
import CountUp from '~/components/CountUp';
import TextCard from '~/components/Dynamic/TextCard';
import Image from '~/components/Dynamic/Image';

export default function CountUpStats({ blok }) {
  return (
    <section className="my-20 md:my-28">
      <div className="container flex flex-col-reverse text-center md:block md:text-left">
        <CountUp endNumber={blok.endNumber} numberContainerClassName="w-1/6 pl-2" numberClassName="py-1 lg:py-7 bg-light-blue leading-[1.31em] text-72px md:text-135px" />

        <div className="flex flex-col -ml-12 md:mt-20 md:flex-row xl:w-2/3">
          <div className="pl-12 max-w-[140px] w-full mx-auto sm:mx-0 hidden md:block">
            <div className="">
              <Image blok={blok.textCard[0].icon} />
            </div>
          </div>
          <div className="flex flex-col pl-12 mb-12 md:mb-0 md:w-4/5 md:mt-0">
            <TextCard
              blok={{
                ...blok.textCard[0],
                icon: '',
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
